import { TFunction } from "i18next";
import validator from "validator";
import { z } from "zod";

export const getContactFormSchema = (t: TFunction) => {
  return z.object({
    email: z.any()
      .transform(val => (typeof val === 'string' && val.trim() === "") ? null : val)
      .nullable()
      .refine(val => val === null || (typeof val === 'string' && validator.isEmail(val)), {
        message: t("entities.entity.contacts.errors.invalid-email"),
      })
      .optional(),
    mobile: z.any()
      .transform(val => (typeof val === 'string' && val.trim() === "") ? null : val)
      .nullable()
      .refine(val => val === null || (typeof val === 'string' && validator.isMobilePhone(val, "any")), {
        message: t("entities.entity.contacts.errors.invalid-mobile-phone"),
      })
      .optional(),
    phone: z.any()
      .transform(val => (typeof val === 'string' && val.trim() === "") ? null : val)
      .nullable()
      .refine(val => val === null || (typeof val === 'string' && validator.isMobilePhone(val, "any")), {
        message: t("entities.entity.contacts.errors.invalid-phone"),
      })
      .optional(),
  }).refine((data) => data.email || data.phone || data.mobile, {
    message: t("entities.entity.contacts.errors.at-least-one-required"),
    path: ["email"],
  });
};

export type ContactForm = z.infer<ReturnType<typeof getContactFormSchema>>;
